module.exports = __webpack_public_path__ + "img/03_sub_no.d7ed07bb.svg";